// Key for storing impersonation info in sessionStorage (for session replay tracking)
export const IMPERSONATION_INFO_KEY = 'levitate_impersonation_info';

export interface IImpersonationInfo {
	isImpersonated: boolean;
	impersonatedByUserId?: string;
	impersonatedByUserName?: string;
}
